//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, {
    useState,
    useCallback,
    useEffect,
    Fragment,
    useContext,
  } from "react";
  import * as moment from "moment";
  import { toast } from "react-toastify";
  import { PDFDownloadLink } from "@react-pdf/renderer";
  
  // custom pages
  import { styles } from "./styles";
  import report from "apis/Report/Report";
  import CiprianReportPDF from "./CiprianReportPDF";
  import DeactivationSummaryReportXLSX from "./DeactivationSummaryReportXLSX";
  import Context from "context/context";
  import useDebounce from "helpers/useDebounce";
  import Dialog from "@material-ui/core/Dialog";
  import Table from "@material-ui/core/Table";
  import TableBody from "@material-ui/core/TableBody";
  import TableCell from "@material-ui/core/TableCell";
  import TableContainer from "@material-ui/core/TableContainer";
  import TableHead from "@material-ui/core/TableHead";
  import TableRow from "@material-ui/core/TableRow";
  import NoData from "components/Table/NoData";
  import Loader from "components/Loader/Loader";
  // material-ui icons
  import HighlightOffIcon from "@material-ui/icons/HighlightOff";
  
  import {dateFormat} from "helpers/dataFormat"
  
  // material-ui
  import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from "@material-ui/pickers";
  import DateFnsUtils from "@date-io/date-fns";
  import Grid from "@material-ui/core/Grid";
  import Button from "@material-ui/core/Button";
  import TextField from "@material-ui/core/TextField";
  import CircularProgress from "@material-ui/core/CircularProgress";
  import Autocomplete from "@material-ui/lab/Autocomplete";
  import MenuItem from "@material-ui/core/MenuItem";
  
  // material-ui icons
  import CheckCircleIcon from "@material-ui/icons/CheckCircle";
  import { useTranslation } from 'react-i18next';
  import { enUS, fr } from "date-fns/locale";
  import { withStyles } from "@material-ui/core/styles";
  import { parse, format } from 'date-fns';
  import { CSVLink } from "react-csv";
  import { WelcomeEmail } from "./config/config";
  const CssTextField = withStyles({
    root: {
      "& label.Mui-focused": {
        color: "##D3D3D3",
      },
      "& .MuiFormLabel-root": {
        color: "#707070",
      },
      "& .MuiInputBase-input": {
        color: "#707070",
      },
      "& .MuiInput-underline:before": {
        borderBottomColor: "#707070!important",
      },
      "& .MuiInput-underline:after": {
        borderBottomColor: "#707070!important",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "#707070",
        },
        "&:hover fieldset": {
          borderColor: "#707070",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#707070",
        },
        "&.MuiOutlinedInput-root": {
          borderRadius: 20,
        },
        "&.MuiOutlinedInput-root": {
          marginTop: 0,
          borderRadius: 20,
        },
      },
    },
  })(TextField);
  export default function WelcomeEmailReport(props) {
    const { state, dispatch } = useContext(Context);
    const { page, setDisableDropdown} = props;
    const {  welcomeEmailReportAPI } = report();
    const classes = styles();
    const { t, i18n } = useTranslation()
    const[data,setData]=useState([])
  const[coulmns,setCoulmns]=useState([])
    const [states, setstates] = useState({
      columns: [],
      selectedColumns:[],
      dialog: false,
      data: [],
      excelData: {},
      pdfData: {},
      response: false,
      startDate: new Date(),
      endDate: new Date(),
      dateApplied: false,
      type: "All",
      eLoading: false,
      pLoading: false,
      searchValue: "",
      searchData: [],
      searchLoading: false,
      loyaltyAccount: [],
      excelBtnActive: false,
      pdfBtnActive: false,
    });
  
    const setStates = useCallback((newState) => {
      setstates((states) => ({ ...states, ...newState }));
    }, []);
    
    const {
      searchLoading,
      searchData,
      searchValue,
      loyaltyAccount,
      excelBtnActive,
      pdfBtnActive,
      rollingMonth
    } = states;
  
  

  
   
   
 
  
    // CustomerStatus api func
    const handleWelcomemailreport = async () => {
        try {
          setDisableDropdown(true);
          let values = {};
          values = {
            startDate: moment(states.startDate).format("MM/DD/YYYY"),
            endDate: moment(states.endDate).format("MM/DD/YYYY"),
          };
    
          let res = await welcomeEmailReportAPI(values);
          //console.log({ res });
          if (res && res.data) {
            dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
            setData( res.data);
            if (res.data.length === 0) {
                toast.success(t("No Data Found"), { toastId: "no-report-date" });
                setStates({eLoading:false});
            setDisableDropdown(false);

                return false;
              }
           setStates({eLoading:false})
            setDisableDropdown(false);
            return true;
          }
        } catch (err) {
          console.log(err);
        }
      };
  
    const locale = i18n.language == 'fr' ? fr : enUS;

    const [currentMonth, setCurrentMonth] = useState(''); 
    const [weeksInMonth, setWeeksInMonth] = useState([]); 
    const [selectedWeek, setSelectedWeek] = useState(null); 
  
   
    const getWeekRange = (startDate) => {
      const dayOfWeek = startDate.getDay();
      const daysSinceThursday = (dayOfWeek + 3) % 7;
  
      const startOfWeek = new Date(startDate);
      startOfWeek.setDate(startDate.getDate() - daysSinceThursday);
  
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6); 
  
      return {
        start: format(startOfWeek, 'MM/dd/yyyy'),
        end: format(endOfWeek, 'MM/dd/yyyy'),
      };
    };
  
   
    const generateWeeksInMonth = (year, month) => {
      const weeks = [];
      const firstDayOfMonth = new Date(year, month, 1);
      const lastDayOfMonth = new Date(year, month + 1, 0);
  
      let currentDay = firstDayOfMonth;
  
      while (currentDay <= lastDayOfMonth) {
        const weekRange = getWeekRange(currentDay);
        weeks.push(weekRange);
        currentDay.setDate(currentDay.getDate() + 7); 
      }
  
      setWeeksInMonth(weeks);
    };
  
   
    useEffect(() => {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth(); 
      
   
      const formattedMonthYear = today.toLocaleString('default', { month: 'long', year: 'numeric' });
      setCurrentMonth(formattedMonthYear);
  
      
      generateWeeksInMonth(year, month);
    }, []);

    const handleWeekChange = (e) => {
        const weekIndex = e.target.value;
        const selectedWeekRange = weeksInMonth[weekIndex];
    
       
        setStates({
          startDate: selectedWeekRange.start,
          endDate: selectedWeekRange.end,
        });
    
       
        setSelectedWeek(weekIndex);
      };
  
    return (
      <div>
     
  
        {/* <div className={classes.headText}>
          {t('Select date range')}{" "}
          {states.dateApplied && (
            <React.Fragment>
              <span className={classes.appliedSpan}>
                <CheckCircleIcon />
              </span>
              <span
                className={classes.removeSpan}
                onClick={() => {
                  if (pdfBtnActive) {
                    setStates({
                      pdfBtnActive: false,
                      dateApplied: false,
                      startDate: new Date(),
                      endDate: new Date(),
                    });
                  }
                  setStates({
                    dateApplied: false,
                    startDate: new Date(),
                    endDate: new Date(),
                  });
                }}
              >
                {t('Remove')}
              </span>
            </React.Fragment>
          )}
        </div>
        <div className={classes.inputsDiv}>
          <Grid container spacing={0}>
            <Grid item xs={12} md={3}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
  
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                  margin="normal"
                  label={t("Start Date")}
                  id="date-picker-inline"
                  className={classes.dateInput}
                  value={states.startDate}
                  maxDate={new Date()}
                  onChange={(date) => {
                    if (pdfBtnActive) {
                      setStates({
                        pdfBtnActive: false,
                      });
                    }
  
                      if (moment(moment(date).format("MM/DD/YYYY")).isAfter(moment(states.endDate).format("MM/DD/YYYY"))) {
                        toast.error("Start date should be less than End date.", {
                          toastId: "start-date-end-date",
                        });
                        setStates({ startDate: null });
                        return;
                      }
                      if (moment(moment(date).format("MM/DD/YYYY")).isAfter(moment(new Date()).format("MM/DD/YYYY"))) {
                        toast.error("Please select valid date (not in the future) for the report. ", {
                          toastId: "start-date-end-date",
                        });
                        setStates({ startDate: null });
                        return;
                      }
                    
                    setStates({ startDate: date, dateApplied: true });
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  autoOk
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={12} md={3}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                  margin="normal"
                  label={t("End Date")}
                  id="date-picker-inline2"
                  className={classes.dateInput}
                  value={states.endDate}
                  maxDate={new Date()}
                  onChange={(date) => {
                    if (pdfBtnActive) {
                      setStates({
                        pdfBtnActive: false,
                      });
                    }
                    if (moment(moment(date).format("MM/DD/YYYY")).isBefore(moment(states.startDate).format("MM/DD/YYYY"))) {
                      toast.error("End date should be greater than Start date.", {
                        toastId: "start-date-end-date",
                      });
                      setStates({ endDate: null });
                      return;
                    } 
                    if (moment(moment(date).format("MM/DD/YYYY")).isAfter(moment(new Date()).format("MM/DD/YYYY"))) {
                      toast.error("End date should be lesser that future date..", {
                        toastId: "start-date-end-date",
                      });
                      setStates({ endDate: null });
                      return;
                    }
                    setStates({ endDate: date, dateApplied: true });
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  autoOk
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>
        </div>
  
  
        <div className={classes.exportAndPreview}>
        
          <Button
            className={classes.exportBtn}
            onClick={async () => {
              if (
                (states?.startDate && !states.endDate) ||
                (!states?.startDate && states.endDate) ||
                (!states?.startDate && !states.endDate)
              ) {
                toast.error(
                  "Please select the both Start-date and End-date values",
                  {
                    toastId: "empty-fields",
                  }
                );
                return;
              }
              if (
                states.startDate?.toString() === "Invalid Date" &&
                states.endDate?.toString() === "Invalid Date"
              ) {
                toast.error("Invalid date.", {
                  toastId: "invalid-date",
                });
                setStates({ startDate: new Date(), endDate: new Date() });
                return;
              } else if (states.startDate?.toString() === "Invalid Date") {
                toast.error("Invalid start date.", {
                  toastId: "invalid-s-date",
                });
                setStates({ startDate: new Date() });
                return;
              } else if (states.endDate?.toString() === "Invalid Date") {
                toast.error("Invalid end date.", {
                  toastId: "invalid-e-date",
                });
                setStates({ endDate: new Date() });
                return;
              }
              setStates({
                response: false,
                excelData: [],
                eLoading: true,
                excelBtnActive: true,
                pdfBtnActive: false,
              });
             
          
           
         
              let res = await handleWelcomemailreport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
            >
        
         
            {states.eLoading ? (
              <React.Fragment>
                <CircularProgress
                  style={{ height: 25, width: 25, color: "#fff" }}
                  variant="determinate"
                  value={state.reportResCount}
                />
                &nbsp;
                <span style={{ color: "#fff", fontWeight: "bold" }}>
                  {state.reportResCount == 0 ? 
                    <div class="snippet">
                      <div class="stage">
                        <div class="dot-typing-e"></div>
                      </div>
                    </div> : `${state.reportResCount}%`}
                </span>
              </React.Fragment>
            ) : (
              t("Export CSV")
            )}
          </Button>
          {(states.eLoading || states.pLoading) && <div style={{ color: 'red', marginLeft: 10 }}>*Please wait don't reload the page, system is processing</div>}
          
          <CSVLink
          id="csv"
          data={data}
          headers={WelcomeEmail}
          skipEmptyLines={true}
          filename={
            `${page}`+"-"+moment(new Date()).format("YYYYMMDD")+ ".csv"
          }
          className={classes.CSVlink}
        />
         
       
        </div> */}
      
<div>
<Grid item xs={12} sm={12} lg={12} className={classes.topGrid}>
          {/* <ThemeProvider theme={formLabelsTheme}> */}
<TextField
              id={"report"}
              label={t("Current Month")}
              select
              required
              type={"text"}
              className={classes.input}
              value={currentMonth}
           
            >
             
                <MenuItem  value={currentMonth} >
                  {currentMonth}
                </MenuItem>
            
            </TextField>
            {/* </ThemeProvider> */}
        </Grid>
        
  
</div>

{weeksInMonth.length > 0 && (
    <Grid item xs={12} sm={12} lg={12} className={classes.topGrid}>
<TextField
              id={"report"}
              label={t("Select Week")}
              select
              required
              type={"text"}
              className={classes.input}
              value={selectedWeek}
              onChange={handleWeekChange}
           
            >
                {weeksInMonth.map((week, index) => (
                <MenuItem value={index} key={t(index)}>
                 Week {index + 1} ({week.start} - {week.end})
                </MenuItem>
              ))}
             
               
            
            </TextField>
            </Grid>
            )}
            <div className={classes.content}>Weekly Report (Thursday to Wednesday)</div>

            <Button
            className={classes.exportBtn}
            onClick={async () => {
              
               
              if (
                (selectedWeek===null) 
               
              ) {
                toast.error(
                  "Please select Week",
                  {
                    toastId: "empty-fields",
                  }
                );
                return;
              }
            
           
              setStates({
                response: false,
                excelData: [],
                eLoading: true,
                excelBtnActive: true,
                pdfBtnActive: false,
              });
             let res = await handleWelcomemailreport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
            >
                {states.eLoading ? (
              <React.Fragment>
                <CircularProgress
                  style={{ height: 25, width: 25, color: "#fff" }}
                  variant="determinate"
                  value={state.reportResCount}
                />
                &nbsp;
                <span style={{ color: "#fff", fontWeight: "bold" }}>
                  {state.reportResCount == 0 ? 
                    <div class="snippet">
                      <div class="stage">
                        <div class="dot-typing-e"></div>
                      </div>
                    </div> : `${state.reportResCount}%`}
                </span>
              </React.Fragment>
            ) : (
              t("Export CSV")
            )}
          </Button>
          {(states.eLoading || states.pLoading) && <div style={{ color: 'red', marginLeft: 10 }}>*Please wait don't reload the page, system is processing</div>}
          
          <CSVLink
          id="csv"
          data={data}
          headers={WelcomeEmail}
          skipEmptyLines={true}
          filename={
            `${page}`+"-"+moment(new Date()).format("YYYYMMDD")+ ".csv"
          }
          className={classes.CSVlink}
        />
         </div>
    );
  }
  